/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';
import * as LS from '../ImageDropZone/styles';

export interface ITextAreaInputProps {
    id: string;
    fontScale?: number;

    label?: string;
    labelColor?: string;
    errorText?: string;
    value?: string;
    required?: boolean;
    placeholder?: string;
    readOnly?: boolean;
    rows?: number;
    hasError?: boolean;
    onCompChange?(id: string, payload: any): void;
}

export const TextAreaInput = ({
    id,
    fontScale,

    label,
    labelColor,
    errorText,
    value,
    required,
    placeholder,
    rows,
    onCompChange,
    readOnly,
    hasError,
}: ITextAreaInputProps) => {
    const [textValue, setTextValue] = useState(value ?? '');
    const [isInvalid, setInvalid] = useState(false);
    useEffect(() => setTextValue(value ?? ''), [value]);

    useEffect(() => {
        if (hasError) {
            setInvalid(true);
        }
        if (!hasError) {
            if (isInvalid) {
                setInvalid(false);
            }
        }
    }, [hasError]);

    const onChange = (id: string, e: any) => {
        setTextValue(e?.target?.value);
        onCompChange && onCompChange(id, e?.target?.value);
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel fontScale={fontScale} color={labelColor}>
                    {label}
                    {required && <sup style={{ color: 'red' }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip" fontScale={fontScale}>
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    document.getElementById(`input-${id}`)?.addEventListener('focusin', (e) => {
        console.log(e, 'moi->');
        document
            .getElementById(`input-group-${id}`)
            ?.classList.add('input-group-ch');
    });
    document
        .getElementById(`input-${id}`)
        ?.addEventListener('focusout', (e) => {
            console.log(e, 'moi->');
            document
                .getElementById(`input-group-${id}`)
                ?.classList.remove('input-group-ch');
        });

    return (
        <>
            <Form.Group id={id} className="formgroup">
                {_renderLabelIf()}
                <InputGroup id={`input-group-${id}`} className="input-group-bt">
                    <S.FormControl
                        fontScale={fontScale}
                        id={`input-${id}`}
                        className="formcontrol form-control shadow-none"
                        value={textValue}
                        onChange={onChange.bind(null, id)}
                        required={required}
                        as="textarea"
                        rows={3}
                        placeholder={placeholder}
                        readOnly={readOnly}
                        isInvalid={isInvalid}
                    />
                </InputGroup>
                <InputGroup>{_renderErrorTextIf()}</InputGroup>
            </Form.Group>
        </>
    );
};

TextAreaInput.defaultProps = {
    required: false,
    hasError: false,
    rows: 3,
    readOnly: false,
};
